import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'Core/guards';
import { UserResolver } from 'Core/resolvers';
import { AppRoutes } from 'Core/routes';

const defaultRoute = AppRoutes.APP;
const routes: Routes = [
  {
    path: AppRoutes.AUTH,
    loadChildren: () => import('Modules/auth/auth.module').then(m => m.AuthenticationModule),
  },
  {
    path: AppRoutes.APP,
    loadChildren: () => import('Modules/shell/shell.module').then(m => m.ShellModule),
    resolve: {
      user: UserResolver,
    },
    canLoad: [AuthGuard],
  },
  {
    path: AppRoutes.WELCOME_PAGE,
    loadChildren: () => import('Modules/welcome/welcome.module').then(m => m.WelcomeModule),
  },

  { path: '**', pathMatch: 'full', redirectTo: defaultRoute },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
